import { carouselData } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {carouselData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">{carouselData.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselData.items.map((item) => (
            <div
              key={item.title}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[2/1] overflow-hidden bg-background-300">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}